import React from 'react';
import {
    Box,
    Card,
    CardContent,
    CardHeader,
    Chip,
    CircularProgress,
    Divider,
    List,
    ListItem,
    ListItemText,
    Typography
} from '@mui/material';
import WarningIcon from '@mui/icons-material/Warning';
import {useFullMenu} from '../../../../hooks/queries/useLogbookQueries';

const EksikUrunler = () => {
    const {data: menuData, isLoading} = useFullMenu();

    if (isLoading) {
        return (
            <Card sx={{mb: 2, display: 'flex', justifyContent: 'center', p: 3}}>
                <CircularProgress size={24}/>
            </Card>
        );
    }

    const tukenenUrunler: any[] = [];
    if (menuData) {
        menuData.forEach((kategori: any) => {
            kategori.sayfalar.forEach((sayfa: any) => {
                sayfa.urunler.forEach((urun: any) => {
                    if (!urun.mevcut) {
                        tukenenUrunler.push({
                            ...urun,
                            sayfaIsmi: sayfa.isim,
                            kategoriIsmi: kategori.isim
                        });
                    }
                });
            });
        });
    }

    return (
        <Card sx={{mb: 2, borderLeft: '5px solid #ffa726'}}>
            <CardHeader
                title={
                    <Box sx={{display: 'flex', alignItems: 'center', gap: 1}}>
                        <WarningIcon color="warning"/>
                        <Typography variant="h6">Eksik Ürünler</Typography>
                    </Box>
                }
            />
            <Divider/>
            <CardContent sx={{p: 0}}>
                {tukenenUrunler.length > 0 ? (
                    <List dense>
                        {tukenenUrunler.map((urun, index) => (
                            <ListItem key={index}>
                                <ListItemText
                                    primary={urun.isim}
                                    secondary={`${urun.kategoriIsmi} > ${urun.sayfaIsmi}`}
                                />
                                <Chip label="Tükendi" size="small" color="error" variant="outlined"/>
                            </ListItem>
                        ))}
                    </List>
                ) : (
                    <Box sx={{p: 3, textAlign: 'center'}}>
                        <Typography color="textSecondary">Şu an eksik bir ürün bulunmuyor.</Typography>
                    </Box>
                )}
            </CardContent>
        </Card>
    );
};

export default EksikUrunler;
